//libs\core\auth\src\lib\guards\public-only.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { TenantAuthService } from '../tenant/tenant-auth.service';

export const publicOnlyGuard: CanActivateFn = (): boolean | UrlTree => {
  const auth = inject(TenantAuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return router.createUrlTree(['/admin/dashboard']);
  }

  return true;
};